import { Collapse } from 'bootstrap';

// Handles accordion scrolling behavior
function scrollToAccordion(target, collapseClass) {
  var targetCollapse = target.querySelector('.' + collapseClass);
  const headerOffset = 50; // header height
  function scrollWithOffset() {
    const elementPosition = target.getBoundingClientRect().top + window.scrollY;
    const offsetPosition = elementPosition - headerOffset;
    window.scrollTo({ top: offsetPosition, behavior: 'smooth' });
  }

  if (targetCollapse) {
    var panel = Collapse.getOrCreateInstance(targetCollapse, { toggle: false });
    if (targetCollapse.classList.contains('show')) {
      scrollWithOffset();
    } else {
      panel.show();
      targetCollapse.addEventListener('shown.bs.collapse', scrollWithOffset, { once: true });
    }
  }
}


// Gets the target element from the hash value
function getTargetFromHash(hash) {
  return hash && hash.length > 1
    ? document.querySelector('[data-wf-anchor="' + hash.substring(1) + '"]')
    : null;
}

// Allows areas to be navigated to from URL hash
function handleAnchorTarget(target) {
  if (target) {
    var type = target.getAttribute('data-wf-anchor-type');
    switch (type) {
      case 'accordion':
        console.log(target);
        scrollToAccordion(target, 'accordion-collapse');
        break;
      case 'tab':
        var navTabs = target.querySelector('.nav-tabs');
        if (navTabs && !navTabs.offsetParent) {
          // Treat as accordion in mobile view
          target = document.querySelector('[data-wf-anchor="accordion-' + target.id + '"]');
          scrollToAccordion(target, 'accordion-tabs-collapse');
        } else {
          // Regular tab scrolling behavior
          target.click();
          navTabs.scrollIntoView({ block: 'start', behavior: 'smooth' });
        }
        break;
      default:
        console.log('Attribute \'data-wf-anchor-type\' is undefined or didn\'t match.');
        break;
    }
  }
}

// Run on page load
document.addEventListener('DOMContentLoaded', function () {
  handleAnchorTarget(getTargetFromHash(window.location.hash));
});

// Run when anchor link is clicked
document.addEventListener('click', function (event) {
  var anchor = event.target;
  if (anchor && anchor.tagName === 'A' && anchor.hash) {
    var target = getTargetFromHash(anchor.hash);
    if (target) {
      event.preventDefault();
      handleAnchorTarget(target);
    }
  }
});

// Run when hash changes
window.addEventListener('hashchange', function () {
  handleAnchorTarget(getTargetFromHash(window.location.hash));
});
